export default __webpack_public_path__ + "static/media/i2000.d58c7e2c.jpg";